export default {
      id: "icon-play-rounded-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "icons.svg#icon-play-rounded",
      toString: function () {
        return this.url;
      }
    }